// Badge responsive sizing
document.addEventListener('DOMContentLoaded', function () {
  const badges = document.querySelectorAll('.badge-responsive');
  badges.forEach(function (badge) {
    badge.style.setProperty('--badge-desktop-width', badge.dataset.desktopWidth + 'px');
    badge.style.setProperty('--badge-desktop-height', badge.dataset.desktopHeight + 'px');
    badge.style.setProperty('--badge-mobile-width', badge.dataset.mobileWidth + 'px');
    badge.style.setProperty('--badge-mobile-height', badge.dataset.mobileHeight + 'px');
  });
});
